var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTechnical = function SvgTechnical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 153 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.88 176H62.1V24.87H.47V0h42.7c7.65 0 13.88 1.64 18.53 4.88 4.06 2.83 6.69 6.86 7.84 11.99h13.91c1.15-5.14 3.77-9.16 7.84-11.99C95.93 1.64 102.202 0 109.932 0h42.58v24.87h-61.63V176Zm-20.78-8h12.78V24.87H70.1V168ZM91.76 16.87h52.751V8h-34.58c-6.06 0-10.8 1.16-14.08 3.44-1.91 1.33-3.27 3.13-4.09 5.43Zm-83.29 0h52.76c-.83-2.3-2.18-4.1-4.1-5.43C53.84 9.16 49.15 8 43.17 8H8.47v8.87Z",
    fill: "#3897FF"
  })));
};

export default SvgTechnical;